module.exports = __webpack_public_path__ + "img/Home-anli-2.d7535a9b.png";